import { Images } from '../../../../data/Assets'

import { ApplicantVisaChance } from '../../../../interfaces/services';
import { ImageAsset } from '../../../wrappers/ImageAsset';

interface IVisaChancesIndicatorProps {
    chance: ApplicantVisaChance | null;
}

const VisaChancesIndicator = (props: IVisaChancesIndicatorProps) => {
    const { chance } = props;

    let asset = null;
    if (chance === ApplicantVisaChance.HIGH) {
        asset = Images.VisaChancesHigh;
    } else if (chance === ApplicantVisaChance.MEDIUM) {
        asset = Images.VisaChancesMedium;
    } else if (chance === ApplicantVisaChance.LOW) {
        asset = Images.VisaChancesLow;
    }


    if (!asset) {
        return null;
    }

    return (
        <div className='immersion__visa_chances__indicator'>
            <ImageAsset src={asset} alt='' />
            <div className='immersion__visa_chances__indicator__text'>
                <span className='immersion__visa_chances__indicator__text_heading'>Visa Chance</span>
                <h3 className='immersion__visa_chances__indicator__text_subheading'>{chance}</h3>
            </div>
        </div>
    )
}

export default VisaChancesIndicator;